module.exports = "https://la-static.prod-my.games/minigames/collection/img/default.7a9cb3f9.png";